module.exports = __webpack_public_path__ + "static/media/blom-pysanky-sm-17.eef8b930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-sm-17.jpg
// module id = 3837
// module chunks = 13